import { CarbonProjectItem } from '@/drive/entities/DriveItem/CarbonProjectItem';
import { CollectionItem } from '@/drive/entities/DriveItem/CollectionItem';
import { FolderItem } from '@/drive/entities/DriveItem/FolderItem';
import { ProductItem } from '@/drive/entities/DriveItem/ProductItem';
import { TransientDriveItem } from '@/drive/entities/transientDriveItem';
import { AccessInheritanceSubject } from '@/drive/types/AccessInheritanceSubject';
import { GlobalAccessLevel } from '@/security/constants/GlobalAccessLevel';

export function toAccessInheritanceSubject(item: TransientDriveItem): Nullable<AccessInheritanceSubject> {
  if (item instanceof ProductItem && item.productId && isDefinedAccess(item.access)) {
    return {
      targetType: 'product',
      id: item.productId,
      title: item.title,
      access: item.access,
      canManageAccess: item.canManageAccess,
    };
  }

  if (item instanceof CarbonProjectItem && item.projectId && isDefinedAccess(item.access)) {
    return {
      targetType: 'project',
      id: item.projectId,
      title: item.title,
      access: item.access,
      canManageAccess: item.canManageAccess,
    };
  }

  if (item instanceof CollectionItem && item.collectionId && isDefinedAccess(item.access)) {
    return {
      targetType: 'collection',
      id: item.collectionId,
      title: item.title,
      access: item.access,
      canManageAccess: item.canManageAccess,
    };
  }

  if (item instanceof FolderItem && item.id && isDefinedAccess(item.access)) {
    return {
      targetType: 'driveFolder',
      id: item.id,
      title: item.title,
      access: item.access,
      canManageAccess: item.canManageAccess,
    };
  }

  return null;
}

function isDefinedAccess(access: ProductItem['access']): access is GlobalAccessLevel {
  return access !== null && access !== undefined;
}
